<template>
  <v-container fluid class="role-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-col md="3">&nbsp;</v-col>
          <v-tab
            :href="`#tab-role`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            Role
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-access`"
          >
            <v-icon class="mr-3">mdi-account-details</v-icon>
            Access
          </v-tab>
          
          <v-tab-item
            :value="'tab-role'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Role</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'rolecode')"
                        v-bind:value="initvalue.rolecode"
                        placeholder="Role Code"
                        persistent-hint
                        single-line hint="Enter the role code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'rolename')"
                        v-bind:value="initvalue.rolename"
                        placeholder="Role Name"
                        persistent-hint
                        single-line hint="Enter the role name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=roletypes
                        :value="initvalue.roletype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'roletype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the role type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'rolestatus')"
                          v-bind:label="initvalue.rolestatus"
                          v-model="initvalue.rolestatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/role/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editRole()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-access'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="8">
                      <p class="text-h5">Role Details</p>
                      <v-form>
                        <v-row justify="center">
                        <v-col md="4">
                          <v-text-field
                            v-model="accessname"
                            v-bind:error="errorindex == 0"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Access Name"
                            persistent-hint
                            single-line hint="Role access name">
                          </v-text-field>
                        </v-col>
                        <v-col md="4">
                          <v-text-field
                            v-model="accesspath"
                            v-bind:error="errorindex == 1"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Access Path"
                            persistent-hint
                            single-line hint="Role access path">
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-switch
                            v-model="accessenabled"
                            :label="role.accessenabled"
                          ></v-switch>
                        </v-col>
                        <v-col md="2">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addAccess()">
                            Add
                          </v-btn>
                        </v-col>
                        </v-row>
                          <v-data-table
                            sort-by="accessname"
                            :headers="headers"
                            :items="access"
                            :items-per-page="500"
                            :footer-props="footer"
                            class="elevation-0"
                          >
                            <template v-slot:top>
                              <v-dialog v-model="editdialog" max-width="500px">
                                <v-card class="edit-dialog" >
                                  <v-card-title>
                                    <span class="headline">Edit</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" md="6">
                                          <v-text-field 
                                          outlined 
                                          v-model="edit_access.accessname" 
                                          v-on:change="updateChangedRoleAccess($event, 'accessname')"
                                          label="Access Name"
                                          >
                                          </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                          <v-text-field 
                                          outlined 
                                          v-model="edit_access.accesspath" 
                                          v-on:change="updateChangedRoleAccess($event, 'accesspath')"
                                          label="Access Path"
                                          >
                                          </v-text-field>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12" class="d-flex align-center">
                                          <v-switch
                                            v-model="edit_access.accessenabled"
                                            v-on:change="updateChangedRoleAccess($event, 'accessenabled')"
                                            :label="edit_access.accessenabled==1 ? 'true': 'false'"
                                          ></v-switch>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" outlined @click="editdialog = false">Cancel</v-btn>
                                    <v-btn color="success" class="button-shadow" @click="editAccess(deleteroleaccess)">Save</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                              <v-dialog v-model="dialog" width="500">
                                <v-card>
                                  <v-card-title>
                                    Delete this Role Access?
                                  </v-card-title>

                                  <v-card-text>
                                    {{ deleteroleaccess.accessname }}
                                  </v-card-text>

                                  <v-divider></v-divider>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                                    <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteroleaccess)">Delete</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="editAccessDialog(item)">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn icon color="primary" @click="deleteItemDialog(item)">
                                <v-icon>mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                      </v-form>
                    </v-col>
                  </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="8">
                      <div class="d-flex justify-center">
                          <v-btn
                            to="/role/list"
                            replace
                            outlined
                            color="primary"
                          >
                            Done
                          </v-btn>
                        <v-spacer></v-spacer>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import axios from 'axios';

export default {
  data () {
    return {
      role: {},
      roleaccess: {},
      headers: [
        { text: 'Name', value: 'accessname' },
        { text: 'Path', value: 'accesspath' },
        { text: 'Enabled', value: 'accessenabled' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      access: [],
      accessname: undefined,
      accesspath: undefined,
      accessenabled: undefined,
      roletypes: ['General', 'Managerial', 'Associate'],
      detail: {},
      deleteroleaccess: {},
      editedIndex: -1,
      edit_access: {},
      menu1: false,
      menu2: false,
      dialog: false,
      editdialog: false,
      pin: {
        error: false,
        error2: false
      },
      initvalue: {

      },
      imageurl: undefined,
      items: ['Full Time', 'Part Time', 'Contract'],
      error: ['Access Name is required', 'Access path is required'],
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('Role', ['updateRoleRequest','getRolesRequest']),
    checkError(){
      if(!this.accessname){
        this.errorindex = 0;
        return false;
      }
      if(!this.accesspath){
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async editRole() {
      this.role._id = this.initvalue._id;
      await this.updateRoleRequest(this.role);
      router.push('/role/list');
    },
    editAccessDialog(item) {
      this.editedIndex = this.access.indexOf(item);
      this.edit_access = Object.assign({}, item);
      this.editdialog = true;
      console.log(item);
    },
    addAccess(){
      if (!this.checkError()){return;}
      let data = {
        accessname: this.accessname,
        accesspath: this.accesspath,
        accessenabled: this.accessenabled,
      };
      console.log(data);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/add/role/access/' + this.initvalue._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then( (response)=> {
        this.access.push(response.data);
      });

    },
    deleteAccess(){
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/role/access/' + this.deleteroleaccess._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then( (response)=> {
        console.log(response.data);
        let index = this.access.findIndex(acc => acc._id == response.data._id);
        this.access.splice(index, 1);
      });

    },
    editAccess(){
      console.log(this.roleaccess);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/role/access/' + this.edit_access._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var put = {
        method: "put",
        url: url,
        headers: header,
        data: this.roleaccess,
      };

      axios(put)
      .then( (response)=> {
        console.log(response.data);
        let index = this.access.findIndex(acc => acc._id == response.data._id);
        this.access.splice(index, 1, response.data);
        this.editdialog = false;
      });

    },
    updateChangedValue(value, field){
      this.role[field] = value;
    },
    updateChangedRoleAccess(value, field){
      this.roleaccess[field] = value;
    },
    deleteItem(item) {
      this.deleteAccess({_id: item._id});
      this.dialog = false;
    },
    deleteItemDialog(item) {
      this.dialog = true;
      console.log(item)
      this.deleteroleaccess = {
        _id: item._id,
        accessname: item.accessname,
      }
    },
  },
  computed: {
    ...mapState('Role', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.access = this.initvalue.access;
    if(!this.initvalue._id) this.$router.push({ name: 'RoleList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
